module.exports = __webpack_public_path__ + "img/i_m_btn_phone.9aa48750.svg";